import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './SingleLinkedProvider.module.css';
import { FormattedCurrency } from '../../../../iwIntlProvider/FormattedCurrency';

const SingleProviderAccount = (props) => {
    const { name, accountNumber, balance } = props;
    return (
        <div className={styles.accountSnippet}>
            <div className={classNames(styles.accountName, 'fs-exclude')}>
                {name}
            </div>
            <div className={classNames(styles.detail, 'fs-exclude')}>
                {accountNumber}
            </div>
            <div className={classNames(styles.balance, 'fs-exclude')}>
                {balance ? (
                    <>
                        <div className={styles.balanceTitle}>
                            <FormattedMessage
                                id="_.single_provider_account.current_balance"
                                defaultMessage="Current balance"
                            />
                        </div>
                        <div>
                            <FormattedCurrency value={balance} />
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default SingleProviderAccount;
